export default [
    { codigo: 1, valor: 'ADMINISTRATIVAMENTE', texto: 'Administrativamente' },
    { codigo: 2, valor: 'DETERMINACAO_TCE', texto: 'Determinação TCE' },
    { codigo: 3, valor: 'DETERMINACAO_JUDICIAL', texto: 'Decisão judicial' }
];